//==============================
// Global
//==============================

// Global variables
var w = $(window);
var ww = w.width();
var wh = w.height();
var html = $('html');
var body = $('body');

FastClick.attach(document.body);

// FitVids
$('.video-gallery-item, .video, .post-content p, .wp-block-embed__wrapper, .home-videos-item').fitVids();

/*
$('.element').waypoint(function(direction) {
  var thisElement = $(this.element);
  //stuff
  this.destroy();
}, {
  offset: '50%'
});
*/

